<script>
import { adminListComputed, adminListMethods } from '@state/helpers/admin-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import { ROLE, LEVEL_ADMIN } from '@utils/constant'
import cloneDeep from 'lodash/cloneDeep'
import { request } from '@/src/services'
import tableFields from './tableFields'
import fieldsBoxCard from './fieldsBoxCard'
export default {
  page: {
    title: 'Admin List',
    meta: [{ name: 'description', content: 'The Admin List page.' }],
  },
  data() {
    return {
      openConfirm: false,
      searching: false,
      fieldsBoxCard: fieldsBoxCard,
      items: {},
      searchBody: new SearchPayload.Builder()
        .withSearchAdminName()
        .withSearchAgent(),
      fields: tableFields,
      deleteList: [],
      roleRequired: [ROLE.SUPER, ROLE.AGENT_ADMIN],
      componentKey: 0,
    }
  },
  computed: {
    ...adminListComputed,
    adminListData() {
      const adminList = cloneDeep(this.getAdminList?.list)
      const data = adminList?.map((admin) => {
        admin.delete = admin.level
        admin.level = LEVEL_ADMIN[admin.level]
        return admin
      })
      return data
    },
    paginationComputed() {
      let paginations = {}
      if (this.getAdminList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getAdminList
        )
      }
      return paginations
    },
    confirmComputed() {
      if (!this.deleteList.length) {
        return 'unselected'
      }
      return 'delete'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
      this.componentKey++
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.handleSearchAdmin()
  },
  methods: {
    ...adminListMethods,
    closeModalConfirm() {
      this.openConfirm = false
    },
    showConfirm() {
      this.openConfirm = true
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchAdmin()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchAdmin()
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchAdmin()
      this.searching = !reset
    },
    handleSearchAdmin() {
      this.fetchingAdminList(this.searchBody)
    },
    watchDeleteList(item) {
      const index = this.deleteList.indexOf(item.admin_id)
      if (!~index) {
        this.deleteList.push(item.admin_id)
      } else {
        this.deleteList.splice(index, 1)
      }
    },
    goToAddNewPage() {
      this.$router.push({ name: 'adminRegistration' })
    },
    viewDetail(id) {
      this.$router.push({
        path: `/panel/admin-list/edit/${id}`,
      })
    },
    onDeleteAdmin() {
      const requests = this.deleteList.map((id) =>
        request({
          endpoint: '/cms/admin/delete/',
          payload: {
            id: id,
          },
        })
      )
      Promise.all(requests).then(() => {
        this.handleSearchAdmin()
        this.closeModalConfirm()
        this.deleteList = []
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseFilterBoxCard
      :key="componentKey"
      :fields="fieldsBoxCard"
      :filter-value="searchBody"
      @filter="handleFilter"
    />
    <BasePagination
      :paginations="paginationComputed"
      :searching="searching"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CButton
          color="dark"
          variant="outline"
          class="py-0"
          @click="goToAddNewPage"
          >新規登録</CButton
        >

        <CButton
          color="dark"
          variant="outline"
          class="py-0 ml-1"
          @click="showConfirm"
          >削除</CButton
        >
      </template>
    </BasePagination>
    <BaseTable
      striped
      border
      hover
      :table-fields="fields"
      :data-tables="adminListData"
      @sorterBy="handleSorter"
      @row-clicked="(item) => viewDetail(item.admin_id)"
    >
      <template v-slot:id="{ item }">
        <td class="py-2" @click.stop="() => {}">
          <CInputCheckbox
            v-if="!roleRequired.includes(item.delete)"
            :checked="deleteList.includes(item.admin_id)"
            color="primary"
            @update:checked="watchDeleteList(item)"
          />
        </td>
      </template>
      <template v-slot:admin_name="{ item }">
        <td>
          {{ item.admin_name }}
        </td>
      </template>
    </BaseTable>
    <BaseModalConfirm
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="!deleteList.length"
      @closeModal="closeModalConfirm"
      @submit="onDeleteAdmin"
    />
  </div>
</template>
